import { render, staticRenderFns } from "./cabinCarrier.vue?vue&type=template&id=3cec4b04&scoped=true&"
import script from "./cabinCarrier.vue?vue&type=script&lang=js&"
export * from "./cabinCarrier.vue?vue&type=script&lang=js&"
import style0 from "./cabinCarrier.vue?vue&type=style&index=0&id=3cec4b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec4b04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cec4b04')) {
      api.createRecord('3cec4b04', component.options)
    } else {
      api.reload('3cec4b04', component.options)
    }
    module.hot.accept("./cabinCarrier.vue?vue&type=template&id=3cec4b04&scoped=true&", function () {
      api.rerender('3cec4b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/cabinCarrier.vue"
export default component.exports